import api from './axiosApi'
import type { Vendor, VendorListResponse } from '@/types/vendor'

export type { Vendor, VendorListResponse }

/**
 * Search vendors by name or vendor code
 * @param params - Search text and page size
 * @returns Promise with matching active vendors
 */
export async function searchVendors(
  params: { q?: string; limit?: number } = {},
  signal?: AbortSignal
): Promise<VendorListResponse> {
  const { q, limit = 20 } = params

  const response = await api.get<VendorListResponse>('/vendors', {
    params: {
      search: q || undefined,
      is_active: true,
      limit,
    },
    signal,
  })

  return response.data
}
